// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'folder-closed';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M2.062 6.796h13.876a1.5 1.5 0 0 1 1.5 1.5v7.818a.75.75 0 0 1-.75.75H1.312a.75.75 0 0 1-.75-.75V8.296a1.5 1.5 0 0 1 1.5-1.5z' />
    <path d='M17.438 10.358v-6.15a.767.767 0 0 0-.767-.767H8.443L7.305 1.514a.767.767 0 0 0-.66-.375H1.329a.767.767 0 0 0-.767.766v8.453' />
  </g>
);

export const viewBox = '0 0 18 18';
